// Display formatters for the My Trades surfaces. Moved verbatim out of
// index.tsx (#341) so the values a trader reads are pinned by golden tests
// rather than buried in the view.
//
// These are deliberately NOT the same as the shared money helpers, and must
// not be folded into them. `formatDollars` renders "$1234.56" while
// `formatMoney` (lib/infra/formatters, used by tableKit's MoneyCell/PnlCell)
// renders "$1,234.56" — both appear on the My Trades screen at once, in
// different tables. Unifying them is a visible change to an accounting
// surface, not a cleanup. See tradeFormat.test.ts, which pins the divergence.

import { fmtCents } from '../../components/cards/cardFormat';
import { describeMarket } from '../../lib/kalshiTicker';

export function formatDollars(cents: number): string {
  const sign = cents < 0 ? '-' : '';
  return `${sign}$${(Math.abs(cents) / 100).toFixed(2)}`;
}

/** Estimate values are centicent-precise (hydra's per-contract fee × count
 *  before any cent-rounding) and need 4 decimals to show what hydra actually
 *  predicts. Actuals stay 2 decimals — Kalshi rounds to whole cents. */
export function formatDollars4(cents: number): string {
  const sign = cents < 0 ? '-' : '';
  return `${sign}$${(Math.abs(cents) / 100).toFixed(4)}`;
}

export function formatTimeOnly(ms: number): string {
  if (!ms) return '';
  return new Date(ms).toLocaleString(undefined, {
    hour: 'numeric',
    minute: '2-digit',
  });
}

export function formatPriceCents(cents: number): string {
  return fmtCents(cents);
}

export function positionLabel(ticker: string, side: 'yes' | 'no'): string {
  const { betTeam } = describeMarket(ticker, side);
  const sideLabel = side === 'yes' ? 'YES' : 'NO';
  return betTeam ? `${sideLabel} (${betTeam})` : sideLabel;
}
